import { Button, IconButton, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { Stack } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { useDrawerContext } from '../../drawer/DrawerContext';
import { useActionFilters } from './useActionFilters';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';

const ActionFiltersButton: FC = () => {
	const theme = useTheme();
	const { setDrawer } = useDrawerContext();
	const [filters] = useActionFilters();

	const filtersCount = Object.values(filters).reduce((count, filterValue) => (filterValue ? count + 1 : count), 0);

	const handleClick = () => {
		setDrawer('actionFilter', {});
	};

	return (
		<>
			<IconButton
				sx={{ border: `1px solid ${theme.palette[getNightOrDayPalette(theme)][500]}`, display: { xs: 'flex', sm: 'none' } }}
				onClick={handleClick}
			>
				<FilterList />
			</IconButton>
			<Button
				onClick={handleClick}
				startIcon={<FilterList fontSize={'large'} sx={{ mt: 0.2 }} />}
				endIcon={
					filtersCount > 0 && (
						<Stack
							justifyContent={'center'}
							alignItems={'center'}
							fontSize={8}
							color={'#fff'}
							bgcolor={theme.palette.primary.main}
							borderRadius={'100%'}
							p={1}
							minWidth={10}
							maxHeight={22}
						>
							<Typography fontSize={'small'}>{filtersCount}</Typography>
						</Stack>
					)
				}
				sx={{ display: { xs: 'none', sm: 'flex' } }}
				variant={'outlined'}
			>
				<FormattedMessage id={'action.list.header.filter'} />
			</Button>
		</>
	);
};

export { ActionFiltersButton };
